/** Whose look the page wears. The data is the same on every name. */
export type Brand = 'vht' | 'alfen';

/**
 * The names that are Alfen's (docs/alfen-portaal-bouwlijst.md, stap 2): the portal
 * there looks like Alfen (`@vht/tokens/brand-alfen.css`). `alfen.localhost` is for
 * local work; a browser resolves every `*.localhost` to this machine.
 *
 * The inline script in `index.html` sets `data-brand` from this same list before
 * first paint; `brand.test.ts` runs that script to keep the two together.
 *
 * The name is never the security boundary: portal data is scoped server-side on
 * the party of the signed-in portal user (`portalScope.ts`).
 */
export const ALFEN_HOSTS = ['logistics.alfen.com', 'logistics-acc.alfen.com', 'alfen.localhost'];

export function brandForHost(hostname: string): Brand {
  return ALFEN_HOSTS.includes(hostname.toLowerCase()) ? 'alfen' : 'vht';
}

/** The brand of this page. */
export function currentBrand(): Brand {
  return brandForHost(window.location.hostname);
}
